import { LOG_PREFIX } from '../app.config';

let attemptedInstall = false;

// eslint-disable-next-line import/prefer-default-export
export const ensureSignupFormValidatorResources = () => {
  if (attemptedInstall) {
    return;
  }
  attemptedInstall = true;

  try {
    const { Roblox } = window;
    const signUpResources = Roblox.Lang.SignUpResources;
    const intl = new Roblox.Intl();

    // This definition copied from:
    // web-platform/Web/RobloxWebSite/js/SignupFormValidatorGeneric.js
    Roblox.Resources.AnimatedSignupFormValidator = {
      maxValid: intl.f(signUpResources['Response.TooManyAccountsWithSameEmailError']),
      invalidEmail: intl.f(signUpResources['Response.InvalidEmail']),
      invalidBirthday: intl.f(signUpResources['Response.InvalidBirthday']),
      loginFieldsRequired: intl.f(signUpResources['Response.UsernamePasswordRequired']),
      loginFieldsIncorrect: intl.f(signUpResources['Response.UsernameOrPasswordIncorrect']),
      doesntMatch: intl.f(signUpResources['Response.PasswordMismatch']),
      passwordIsUsername: intl.f(signUpResources['Response.PasswordContainsUsernameError']),
      requiredField: intl.f(signUpResources['Label.Required']),
      tooShort: intl.f(signUpResources['Response.PasswordWrongShort']),
      weakKey: intl.f(signUpResources['Response.PasswordComplexity']),
      invalidCharacters: intl.f(signUpResources['Response.SpaceOrSpecialCharaterError']),
      invalidName: intl.f(signUpResources['Response.UsernameAllowedCharactersError']),
      cantBeUsed: intl.f(signUpResources['Response.BadUsername']),
      cantBeUsedPii: intl.f(signUpResources['Response.UsernamePrivateInfo']),
      alreadyTaken: intl.f(signUpResources['Response.UsernameAlreadyInUse']),
      userNameInvalidLength: intl.f(signUpResources['Response.UsernameInvalidLength']),
      startsOrEndsWithUnderscore: intl.f(signUpResources['Response.UsernameInvalidUnderscore']),
      moreThanOneUnderscore: intl.f(signUpResources['Response.UsernameTooManyUnderscores']),
      birthdayRequired: intl.f(signUpResources['Response.BirthdayMustBeSetFirst']),
      passwordRequired: intl.f(signUpResources['Response.PleaseEnterPassword']),
      usernameRequired: intl.f(signUpResources['Response.PleaseEnterUsername']),
      passwordConfirmationRequired: intl.f(signUpResources['Response.PasswordConfirmation']),
      usernameNoRealNameUse: intl.f(signUpResources['Message.Username.NoRealNameUse']),
      passwordMinLength: intl.f(signUpResources['Message.Password.MinLength']),
      usernameNotAvailable: intl.f(signUpResources['Response.UsernameNotAvailable'])
    };

    // eslint-disable-next-line no-console
    console.log(LOG_PREFIX, 'Installed signup form validator resources');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(LOG_PREFIX, 'Could not ensure signup form validator resources');
  }
};
